import { z } from 'zod'

export const isInwardProcessingProcedure = (procedureCode: string): boolean =>
  procedureCode === '51' || procedureCode === '54'

export type BulkUpdateCustomsFormData = {
  requestedCustomsProcedure: string
  previousCustomsProcedure: string
}

const schema = z
  .object({
    requestedCustomsProcedure: z.string(),
    previousCustomsProcedure: z.string()
  })
  .refine(
    data =>
      data.requestedCustomsProcedure !== '' || data.previousCustomsProcedure !== '',
    { message: 'At least one field must be selected for update' }
  )

export const getInitialFormData = (): BulkUpdateCustomsFormData => ({
  requestedCustomsProcedure: '',
  previousCustomsProcedure: ''
})

export const validateBulkUpdateCustomsForm = (data: BulkUpdateCustomsFormData) =>
  schema.safeParse(data)

export const EMPTY_VALUE = '__EMPTY__'
